var exports = {
  "a": "Box__jQ8Tkq",
  "w": "Box_1__CBhjzs",
};

module.exports = exports;
